import api from './api';

const partyUrl = '/party';

export function getParties() {
  return api.get(`${partyUrl}/get-parties`).catch((err: any) => {
    return err;
  });
}

export function getChildParties(parentPartyId: number) {
  return api.get(`${partyUrl}/get-parties/${parentPartyId}`).catch((err: any) => {
    return err;
  });
}

export function getAssignedParties() {
  return api.get(`${partyUrl}/get-assigned-parties`).catch((err: any) => {
    return err;
  });
}

export function updatePartyLanguage(partyId: number, instructionId: number, languageTC: string) {
  return api.post(`${partyUrl}/language`, {
                    partyId: partyId,
                    instructionId: instructionId,
                    languageTC: languageTC })
                    .catch(err => {
    console.error(err);
    return err;
  });
}
